// Custom domain → ChessWeb player profile mapping
// To add a new domain: add one line here, then follow /add-custom-domain skill
//
// Routing behavior (see App.js):
//   - Root path (/) and /donate render PlayerProfilePreview for the mapped username
//   - All other paths (e.g. /coach/:username/checkout, /blog/*, /shop/*) fall through
//     to React Router and work normally — they are NOT intercepted by the domain check
//   - The domain must also be added to Firebase Hosting authorized domains
export const customDomains = {
  'indiechess.com': 'IndieChess',
  'exclusivechess.com': 'thechessnerd',
  'charlizevz.com': 'charlize',
  'northcoastchessclub.org': 'northcoastchessclub',
  'gmsindarov.com': 'javokhirsindarov',
  'mtrchessclub.com': 'mtrcc',
};
